class QuantityControlsV2 extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default values
    this.min = parseInt(this.getAttribute('min') || '1');
    this.max = parseInt(this.getAttribute('max') || '10');
    this.value = parseInt(this.getAttribute('value') || '1');
    this.showBorder = this.getAttribute('show-border') === 'true';
    
    this.render();
    this.setupEventListeners();
  }
  
  static get observedAttributes() {
    return ['min', 'max', 'value', 'show-border'];
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      switch (name) {
        case 'min':
          this.min = parseInt(newValue);
          break;
        case 'max':
          this.max = parseInt(newValue);
          break;
        case 'value':
          this.value = parseInt(newValue);
          this.updateValueDisplay();
          break;
        case 'show-border':
          this.showBorder = newValue === 'true';
          this.render();
          this.setupEventListeners();
          break;
      }
    }
  }
  
  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .quantity-controls {
          display: flex;
          align-items: center;
          border-radius: 6px;
          overflow: hidden;
          ${this.showBorder ? 'border: 1px solid #ddd;' : ''}
        }
        
        .qty-btn {
          background: #fff;
          border: none;
          width: 36px;
          height: 42px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333;
          transition: background 0.2s;
        }
        
        .qty-btn:hover {
          background: #f5f5f5;
        }
        
        .qty-input {
          width: 50px;
          height: 42px;
          text-align: center;
          border: none;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          font-size: 16px;
          -moz-appearance: textfield;
        }
        
        .qty-input::-webkit-outer-spin-button,
        .qty-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      </style>
      <div class="quantity-controls">
        <button type="button" class="qty-btn" id="qty-decrease">−</button>
        <input type="number" value="${this.value}" min="${this.min}" max="${this.max}" class="qty-input" id="quantity-input">
        <button type="button" class="qty-btn" id="qty-increase">+</button>
      </div>
    `;
  }
  
  setupEventListeners() {
    const qtyInput = this.shadowRoot.getElementById('quantity-input');
    const qtyDecrease = this.shadowRoot.getElementById('qty-decrease');
    const qtyIncrease = this.shadowRoot.getElementById('qty-increase');
    
    console.log('setupEventListeners called', { qtyInput, qtyDecrease, qtyIncrease });
    
    if (!qtyDecrease || !qtyIncrease || !qtyInput) {
      console.error('quantity-controls-v2: Could not find button elements');
      return;
    }
    
    qtyDecrease.addEventListener('click', (e) => {
      console.log('Decrease clicked, current value:', this.value, 'min:', this.min);
      if (this.value > this.min) {
        this.value--;
        this.updateValueDisplay();
        console.log('New value:', this.value);
        this.dispatchEvent(new CustomEvent('quantity-change', { 
          detail: { value: this.value },
          bubbles: true,
          composed: true
        }));
      }
    });
    
    qtyIncrease.addEventListener('click', (e) => {
      console.log('Increase clicked, current value:', this.value, 'max:', this.max);
      if (this.value < this.max) {
        this.value++;
        this.updateValueDisplay();
        console.log('New value:', this.value);
        this.dispatchEvent(new CustomEvent('quantity-change', { 
          detail: { value: this.value },
          bubbles: true,
          composed: true
        }));
      }
    });
    
    qtyInput.addEventListener('change', () => {
      let newValue = parseInt(qtyInput.value);
      if (isNaN(newValue)) {
        newValue = this.min;
      } else if (newValue < this.min) {
        newValue = this.min;
      } else if (newValue > this.max) {
        newValue = this.max;
      }
      
      this.value = newValue;
      this.updateValueDisplay();
      this.dispatchEvent(new CustomEvent('quantity-change', { 
        detail: { value: this.value },
        bubbles: true,
        composed: true
      }));
    });
  }
  
  updateValueDisplay() {
    const qtyInput = this.shadowRoot.getElementById('quantity-input');
    if (qtyInput) {
      qtyInput.value = this.value;
    }
    
    // Sync to input[name=quantity] in the parent form
    const form = this.closest('form');
    if (form) {
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = this.value;
      }
    }
  }
  
  // Public method to get current value
  getValue() {
    return this.value;
  }
  
  // Public method to set value
  setValue(value) {
    const newValue = parseInt(value);
    let clampedValue = newValue;
    if (clampedValue < this.min) {
      clampedValue = this.min;
    } else if (clampedValue > this.max) {
      clampedValue = this.max;
    }
    
    // Only update and dispatch if value actually changed
    if (clampedValue !== this.value) {
      this.value = clampedValue;
      this.updateValueDisplay();
      this.dispatchEvent(new CustomEvent('quantity-change', { 
        detail: { value: this.value },
        bubbles: true,
        composed: true
      }));
    } else {
      this.updateValueDisplay();
    }
  }
}

customElements.define('quantity-controls-v2', QuantityControlsV2);